// eslint-disable-next-line no-use-before-define
import * as React from 'react';
import createAsyncCallback from '@loki/create-async-callback';

export const AsyncStoryDecorator = Story => {
    const asyncCallback = createAsyncCallback();
    setTimeout(asyncCallback, 3000);
    return <Story />;
};
